import { render, staticRenderFns } from "./CheckoutAlbigny.vue?vue&type=template&id=d1c3974c&"
import script from "./CheckoutAlbigny.vue?vue&type=script&lang=js&"
export * from "./CheckoutAlbigny.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports